<template>
  <div class="notice-card-container">
    <!-- <div class="notice-title-content">
      <div class="system-notice-title">系统公告</div>
      <div class="more" @click="handleMore">更多</div>
    </div> -->
    <template v-if="tableLoading">
      <el-table v-loading="tableLoading" height="230px"></el-table>
    </template>
    <template v-else>
      <div class="card-content" v-for="item in noticeList" :key="item.title">
        <div class="card-title" :title="item.title" @click="toDetail(item)">{{ item.title }}</div>
        <div class="card-date">{{ item.uploadTime }}</div>
      </div> 
    </template>
    
  </div>
</template>
<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import moment from 'moment'

export default{
  data(){
    return{
      tableLoading: false,
      noticeList:[],
      currentPage:1,
      visibleType:null
    }
  },
  methods:{
    h_i18n,
    // handleMore(){
    //   let urls = ''
    //   if(process.env.NODE_ENV != 'production'){
    //     urls = `http://sqm-test.qd-huangdao-test.haier.net/supplierSystem_new_2024?resourceId=99&roleCode=${this.$route.query.roleCode}&supplyCode=${this.$route.query.supplyCode}&dataFrom=sqm`   
    //   }else{
    //     urls = `http://sqm-test.qd-huangdao-test.haier.net/supplierSystem_new_2024?resourceId=99&roleCode=${this.$route.query.roleCode}&supplyCode=${this.$route.query.supplyCode}&dataFrom=sqm`
    //   }
    //   window.open(`${urls}`)
    // },
    getNoticeList(){
      this.tableLoading = true
      this.$http({
        method: "post",
        url: "/base/notice/list",
        data: {
          current:this.currentPage,
          size:10,
          noticeType:1,
          visibleType: this.visibleType
        },
      }).then((res) => {
        this.tableLoading = false
        if(res&&res.data&&res.data.data&&res.data.data.records&&res.data.data.records.length>0){
          let list = res.data.data.records
          list.forEach((e,i)=>{
            e.uploadTime = e.uploadTime ? ((moment(e.uploadTime)).format('YYYY-MM-DD')):''
            if(i<7){
              this.noticeList.push(e)
            }
          })
        }  
      }).catch(err=>{
        this.tableLoading = false
        this.info(err.data.msg)
      })
    },
    toDetail(item){
      if(item.fileUuid.includes('https')){
        window.open(item.fileUuid)
      }else{
        if((item.noticeContent==''||item.noticeContent==null||item.noticeContent==undefined)&&item.fileUuid){
          window.open(`https://sqm.haier.net/readFile/${item.fileUuid}`)
        }else{
          let urls = ''
          if(process.env.NODE_ENV != 'production'){
            urls = 'https://pre-proxy-sqm.hwork.haier.net/hmqm/#'   
          }else{
            urls = 'https://sqm.haier.net/workBench/#'
          }
          window.open(`${urls}/noticeDetail?id=${item.noticeId}&name=${this.$route.query.name}&nickName=${this.$route.query.nickName}&dataFrom=hmqm&group=SystemNotice`)
        }
      }
    }
  },
  mounted(){
    if(this.$route.query.isAdmin){
      this.visibleType = 0
    }else{
      if(this.$route.query.roleCode&&((this.$route.query.roleCode).includes('S')||(this.$route.query.roleCode).includes('s'))){
        this.visibleType = 2
      }else {
        this.visibleType = 1
      }
    }
    this.getNoticeList()
  }
}
</script>

<style lang="scss" scoped>
.notice-card-container{
  width: 100%;
  background: #fff;
  height: 251px;
  padding-top: 8px;
  .notice-title-content{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    .system-notice-title{
      font-size: 14px;
      font-weight: bold;
      color: #1D2129;
    }
    .more{
      cursor: pointer;
      color: #165dff;
      font-size: 12px;
      // .icon-style{
      //   font-size: 14px;
      //   font-weight: bold;
      // }
    }
  }
  .card-content{
    height: 30px;
    line-height: 30px;
    color: #333;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .card-title{
      width: 220px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      cursor: pointer;
      color: #1D2129;
      font-size: 14px;
      &:hover{
        color: #165dff;
      }
    }
    .card-date{
      font-size: 14px;
      width: 90px;
      color: #86909C;
    }
  }
}
</style>